




































































































import Vue from 'vue';

import AppBar from '@/components/AppBar.vue';
import Note from '@/components/Note.vue';
import NoteThumbnail from '@/components/NoteThumbnail.vue';

export default Vue.extend({
  components: {
    AppBar,
    Note,
    NoteThumbnail,
  },
  data(): { pageId: string } {
    return {
      pageId: '',
    };
  },
  computed: {
    spaceId(): string {
      return this.$route.params.spaceid;
    },
    pages: function(): any[] {
      const pages = this.$store.state.pages
        ? this.$store.state.pages.map((page: any) => page.id)
        : [];
      // return pages;
      return [...pages, ...(this.pageId ? [this.pageId] : [])];
    },
    allNotes(): any[] {
      const notes = this.$store.state.notes.filter((note: any) => {
        if (this.$store.state.loggedIn) {
          return ![this.$store.state.user.draft.id].includes(note.id);
        } else {
          return true;
        }
      });
      const sorted = Array.from(notes).sort((a: any, b: any) => {
        return b.lastUpdated.seconds - a.lastUpdated.seconds;
      });
      return sorted;
    },
    pageNotes: function(): any[] {
      // console.log('pageNotes', this.$store.state.page ? this.$store.state.page.notes : []);
      return this.$store.state.page ? this.$store.state.page.notes : [];
    },
  },
  watch: {
    pageId() {
      if (!this.pageId) {
        return;
      }
      this.updatePage();
    },
  },
  methods: {
    isOwner() {
      return this.$store.state.user
        ? this.spaceId === this.$store.state.user.space.id
        : false;
    },
    async addToPage(noteId: string) {
      await this.$store.dispatch('addNoteToPage', { noteId: noteId });
    },
    async removeFromPage(noteId: string) {
      await this.$store.dispatch('removeNoteFromPage', { noteId: noteId });
    },
    async updatePage() {
      await this.$store.dispatch('bindPage', {
        spaceId: this.spaceId,
        pageId: this.pageId,
      });
      await this.$store.dispatch('bindPageRef', {
        spaceId: this.spaceId,
        pageId: this.pageId,
      });
    },
  },
  created() {
    this.pageId = this.$route.params.pathMatch;
    if (this.pageId === '*') {
      this.pageId = '';
    }
    this.$store.dispatch('bindPages', { spaceId: this.spaceId });
    this.$store.dispatch('bindNotes', { spaceId: this.spaceId });
  },
});
